import { mapEnum } from 'Commons/helpers/utils/Formatter';

const EXEMPT_FROM_LIST = mapEnum(['GATE_LOCKOUT', 'OVERLOCK', 'OTHER_LATE_EVENTS', 'TAX_EXEMPT']);

export { EXEMPT_FROM_LIST };
